import React from 'react';
import PropTypes from 'prop-types';
import { getCircleButtonClass } from 'components/v2/buttons/CircleButton';
import ImageIcon from 'components/v2/icons/ImageIcon';
import DocumentIcon from 'components/v2/icons/DocumentIcon';
import DeleteButton from 'components/v2/buttons/DeleteButton';
import { getClassName } from 'utils/ui/classes';
import { isImageFile } from 'helpers/helper_functions';
import { useTranslation } from 'react-i18next';
const baseClasses = ['flex', 'items-center', 'space-x-4'];
const DocumentUpload = ({ name, filename, onDelete, className }) => {
    const fileExt = filename.split('.').pop();
    const isImage = isImageFile(fileExt);
    return (React.createElement("div", { className: getClassName(baseClasses, className) },
        React.createElement("div", { className: "flex items-center space-x-2" },
            React.createElement("div", { className: getCircleButtonClass('gray') },
                isImage && React.createElement(ImageIcon, null),
                !isImage && React.createElement(DocumentIcon, null)),
            React.createElement("span", { title: name, className: "w-64 text-sm text-gray-900 truncate" }, name)),
        React.createElement(DeleteButton, { onClick: onDelete })));
};
DocumentUpload.propTypes = {
    name: PropTypes.string.isRequired,
    filename: PropTypes.string.isRequired,
    onDelete: PropTypes.func.isRequired,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
};
export default DocumentUpload;
